import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface EngagementPathwayCardProps {
  title: string;
  description: string;
  iconName: string;
  benefits: string[];
  ctaText: string;
  onSelect: () => void;
}

const EngagementPathwayCard: React.FC<EngagementPathwayCardProps> = ({
  title,
  description,
  iconName,
  benefits,
  ctaText,
  onSelect,
}) => {
  return (
    <div className="bg-card rounded-lg p-6 border border-border hover:shadow-lg transition-all duration-300 hover:scale-105">
      <div className="flex items-start space-x-4 mb-4">
        <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name={iconName as any} size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-headline font-bold text-foreground mb-2">{title}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      
      <div className="mb-6">
        <h4 className="text-sm font-semibold text-foreground mb-3">What You'll Get:</h4>
        <ul className="space-y-2">
          {benefits.map((benefit, index) => (
            <li key={index} className="flex items-start space-x-2">
              <Icon name="CheckCircleIcon" size={16} className="text-success flex-shrink-0 mt-0.5" />
              <span className="text-sm text-foreground">{benefit}</span>
            </li>
          ))}
        </ul>
      </div>
      
      <button
        onClick={onSelect}
        className="w-full px-6 py-3 bg-primary text-primary-foreground rounded-md font-cta text-sm font-bold transition-all duration-300 hover:bg-primary/90 hover:shadow-md"
      >
        {ctaText}
      </button>
    </div>
  );
};

export default EngagementPathwayCard;